import { render, staticRenderFns } from "./VariantSifterSectionDrawers.vue?vue&type=template&id=06278c95&scoped=true&"
import script from "./VariantSifterSectionDrawers.vue?vue&type=script&lang=js&"
export * from "./VariantSifterSectionDrawers.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterSectionDrawers.vue?vue&type=style&index=0&id=06278c95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06278c95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06278c95')) {
      api.createRecord('06278c95', component.options)
    } else {
      api.reload('06278c95', component.options)
    }
    module.hot.accept("./VariantSifterSectionDrawers.vue?vue&type=template&id=06278c95&scoped=true&", function () {
      api.rerender('06278c95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterSectionDrawers.vue"
export default component.exports